"use client"

import { Minimize } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MinimizeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MinimizeIcon = component(Icon)({ as: Minimize })
